import { Component, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-search-key-create',
  templateUrl: './search-key-create.component.html',
  styleUrls: ['./search-key-create.component.scss']
})
export class SearchKeyCreateComponent {
  addEvent = new EventEmitter<string>();

  keyControl = new FormControl();

  add() {
    this.addEvent.emit(this.keyControl.value);
  }
}
